import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fi from "./fi.json";
import sv from "./sv.json";

// tslint:disable-next-line: no-floating-promises
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fi",
    interpolation: {
      escapeValue: false,
    },
    preload: ["fi", "sv"],
    ns: ["common"],
    defaultNS: "common",
    debug: process.env.NODE_ENV === "development",
    resources: {
      fi: {
        common: fi,
      },
      sv: {
        common: sv,
      },
    },
  });

i18n.languages = ["fi", "sv"];

export default i18n;
